<template>
    <div class="accordion__group" :class="isOpen ? 'accordion__group--isOpen' : ''">

        <div class="accordion__group__title">
            <slot name="accordion"></slot>
            <button class="accordion__group__button" type="button" name="button" @click="isOpen = !isOpen">
                <svg viewBox="0 0 24 24" class="accordion__chevron" :class="isOpen ? 'accordion__chevron--rotate' : ''"><use xlink:href="#chevron-down"></use></svg>
            </button>
        </div>
        <div class="accordion__group__content">
            <slot>
            </slot>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        showOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    created() {
        this.isOpen = this.showOpen;
    }
}
</script>

<style lang="scss">
.accordion__group__content {
    display: none;
}

.accordion__group--isOpen .accordion__group__content {
    display: initial;
}
</style>
